export const WEB3FORMS_KEY = (import.meta.env?.VITE_WEB3FORMS_KEY || '').trim();